import { defineMessage } from 'services/localization';

export const messages = {
    backend: defineMessage('backend'),
    active: defineMessage('active_1'),
    apply: defineMessage('apply'),
    reset: defineMessage('reset'),
    example: defineMessage('example_localhost'),
    selectBackendFirst: defineMessage('select_a_backend_first'),
    myAccount: defineMessage('my_account'),
    slack: defineMessage('slack'),
    adminPanel: defineMessage('admin_panel'),
    identityServer: defineMessage('identity_server'),
    developerPortal: defineMessage('developer_portal'),
};
